export const SparklesIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
      <path
        stroke="#492983"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M5 3.52v4-4zm-2 2h4-4zm3 12v4-4zm-2 2h4-4zm9-16l2.286 6.856L21 12.52l-5.714 2.143L13 21.52l-2.286-6.857L5 12.52l5.714-2.143L13 3.52z"
      />
    </svg>
  );
};
export default SparklesIcon;
